/* eslint-disable */
window.googleTranslateElementInit = function() {
  $('#google_translate_element').empty();
  new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE}, 'google_translate_element');
}
